<template>
    <b-col :class="border ? 'border-right' : ''" cols="6">
        <rules-table v-if="!showInputs" :compare="true" :scenarioName="scenarioName"></rules-table>
        <div
            v-if="showInputs"
        >
            <b-row 
                v-for="field in scenario.fields"
                :key="field.name"
                class="mt--3 mb--5"
            >
                <b-col cols="12" >
                    <QduInput
                        :field="field"
                        :isDisabled="true"
                        :scenarioName="scenarioName"
                        :different="field.status"
                    /> 
                </b-col>
            </b-row>
        </div>
    </b-col>
</template>

<script>
import QduInput from '@/components/Inputs/ToolInputs/QduInput';
import RulesTable from '@/components/Results/RulesTable'

export default {
    components: {
        RulesTable,
        QduInput,
    },
    props: {
        scenario: Object,
        showInputs: Boolean,
        border: Boolean,
        scenarioName: String
    },
}
</script>

<style>
.no-show {
  width: 0;
  height: 0;
  position: absolute;
  visibility: hidden;
}
</style>